function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTextCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "message-text-circle-02",
    clipPath: "url(#clip0_5369_243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.554688 5.99969C0.554688 2.9925 2.9925 0.554688 5.99969 0.554688C9.00688 0.554688 11.4447 2.9925 11.4447 5.99969C11.4447 9.00688 9.00688 11.4447 5.99969 11.4447C5.27633 11.4447 4.58475 11.3034 3.95195 11.0464C3.89448 11.023 3.86036 11.0092 3.8349 10.9997C3.82505 10.996 3.81904 10.9939 3.81602 10.9929L3.81457 10.9926L3.81164 10.9925C3.80933 10.9928 3.80497 10.9932 3.79796 10.9942C3.77664 10.9971 3.74802 11.0018 3.69552 11.0105L1.72368 11.3392C1.63452 11.3541 1.53802 11.3702 1.45477 11.3765C1.36448 11.3833 1.22605 11.3851 1.08072 11.3228C0.89915 11.2449 0.754462 11.1002 0.676585 10.9187C0.61425 10.7733 0.616096 10.6349 0.622912 10.5446C0.629196 10.4613 0.645307 10.3648 0.660192 10.2757L0.988832 8.30385C0.997582 8.25135 1.0023 8.22273 1.00519 8.20141C1.00614 8.1944 1.00662 8.19004 1.00685 8.18773L1.0068 8.18481L1.0065 8.18336C1.00549 8.18034 1.00342 8.17433 0.999715 8.16448C0.990155 8.13902 0.97634 8.10489 0.953001 8.04743C0.696006 7.41463 0.554688 6.72305 0.554688 5.99969ZM5.99969 1.54469C3.53926 1.54469 1.54469 3.53926 1.54469 5.99969C1.54469 6.59318 1.66048 7.15841 1.87024 7.67491C1.8735 7.68293 1.87682 7.69107 1.88018 7.69931C1.91417 7.78261 1.95221 7.87584 1.9716 7.96233C1.98931 8.04133 1.99689 8.10979 1.9969 8.19075C1.99691 8.27913 1.98182 8.36879 1.96887 8.44573C1.96768 8.4528 1.9665 8.45976 1.96536 8.46661L1.65188 10.3475L3.53277 10.034C3.53961 10.0329 3.54657 10.0317 3.55364 10.0305C3.63058 10.0176 3.72024 10.0025 3.80862 10.0025C3.88958 10.0025 3.95805 10.0101 4.03705 10.0278C4.12353 10.0472 4.21676 10.0852 4.30006 10.1192C4.30829 10.1225 4.31644 10.1259 4.32447 10.1291C4.84096 10.3389 5.40619 10.4547 5.99969 10.4547C8.46012 10.4547 10.4547 8.46012 10.4547 5.99969C10.4547 3.53926 8.46012 1.54469 5.99969 1.54469ZM3.30469 4.62469C3.30469 4.35131 3.52631 4.12969 3.79969 4.12969H5.99969C6.27307 4.12969 6.49469 4.35131 6.49469 4.62469C6.49469 4.89807 6.27307 5.11969 5.99969 5.11969H3.79969C3.52631 5.11969 3.30469 4.89807 3.30469 4.62469ZM3.30469 6.54969C3.30469 6.27631 3.52631 6.05469 3.79969 6.05469H7.64969C7.92307 6.05469 8.14469 6.27631 8.14469 6.54969C8.14469 6.82307 7.92307 7.04469 7.64969 7.04469H3.79969C3.52631 7.04469 3.30469 6.82307 3.30469 6.54969Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5369_243"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.5 0.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTextCircle);
export default __webpack_public_path__ + "static/media/message-text-circle.550a57bc2fb4dbf73e6e607664ace967.svg";
export { ForwardRef as ReactComponent };